<drill-down-report [report]="report" [reportName]="reportName" [drillDownGroups]="drillDownGroups">
</drill-down-report>